<template>
  <div class="limit-box">
    <span class="limit-btn" @click="handleDecrease">-</span>
    <span class="limit-value">{{ value }}</span>
    <span class="limit-btn" @click="handleIncrease">+</span>
  </div>
</template>

<script>
export default {
  name: "LimitBox",
  props: {
    value: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 100,
    },
  },
  methods: {
    handleDecrease() {
      if (this.value > this.min) {
        this.$emit("change", this.value - 1);
      }
    },
    handleIncrease() {
      if (this.value < this.max) {
        this.$emit("change", this.value + 1);
      }
    },
  },
};
</script>

<style scoped lang="less">
.limit-box {
  display: flex;
  background: #f3f4f6;
  border-radius: 4px;
  height: 32px;
  box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.1);
  .limit-btn {
    width: 32px;
    height: 32px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 20px;
    line-height: 32px;
    font-weight: bold;
    user-select: none;
    // &:hover {
    //   background: #e5e7eb;
    // }

    // &:active {
    //   background: #d1d5db;
    // }
  }

  .limit-value {
    font-size: 24px;
    font-weight: 600;
    color: #0e756a;
    min-width: 40px;
    text-align: center;
    background: #fff;
    line-height: 32px;
  }
}
</style>
